var React = require('react');

function ArrowheadDownOutline (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"arrowhead-down"},[React.createElement("rect",{"width":"24","height":"24","opacity":"0","key":0}),React.createElement("path",{"d":"M17.37 12.39L12 16.71l-5.36-4.48a1 1 0 1 0-1.28 1.54l6 5a1 1 0 0 0 1.27 0l6-4.83a1 1 0 0 0 .15-1.41 1 1 0 0 0-1.41-.14z","key":1}),React.createElement("path",{"d":"M11.36 11.77a1 1 0 0 0 1.27 0l6-4.83a1 1 0 0 0 .15-1.41 1 1 0 0 0-1.41-.15L12 9.71 6.64 5.23a1 1 0 0 0-1.28 1.54z","key":2})])));
}

ArrowheadDownOutline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowheadDownOutline;

ArrowheadDownOutline.default = ArrowheadDownOutline;
